"use client"
import { createAuthClient } from "better-auth/react"
import { twoFactorClient } from "better-auth/client/plugins"
import { protectedFetch } from "./protected-fetch"

export const authClient = createAuthClient({ plugins: [twoFactorClient()], fetchOptions: { customFetchImpl: protectedFetch } })
